<template>
    <div id="suggested_order" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <!-- <span class="page-title" id="CardRateHeader" v-if="$route.params.id > 0" >Discount Rates</span> -->
                    <span class="page-title" id="CardRateHeader">Suggested Order</span>
                        <!-- <div class="web-action-btn">
                            <div class="btn-groups text-right">
                            <button type="submit" class="btn btn-secondary" v-on:click.prevent="customerStatementSend('download')" >
                                Download
                            </button>
                            <button type="submit" class="btn btn-primary" v-on:click.prevent="sendMail" >
                                Send
                            </button>
                            </div>
                        </div> -->
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content customer-statement">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="suggestedOrderForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="location_id">Warehouse:</label>
                                        <v-select v-model="warehouse_id" name="warehouse_id" placeholder="Select Warehouse."
                                                label="text"
                                                :options="warehouseArr">
                                        </v-select>
                                        <div class="field-error">{{warehouse_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label" for="vendor_id">Vendor:</label>
                                        <v-select v-model="vendor_id" name="vendor_id"
                                                label="text" :filterable="false" :options="vendorArr"
                                                @search="onSearchVendor"
                                                placeholder="Select Vendor" class="custom-ci-auto-search">
                                            <template slot="no-options">
                                                Search Vendor...
                                            </template>
                                            <template slot="option" slot-scope="option">
                                                <div class="d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                            <template slot="selected-option" slot-scope="option">
                                                <div class="selected d-center">
                                                    {{ option.text }}
                                                </div>
                                            </template>
                                        </v-select>
                                        <!-- <div class="field-error" id="customererror">{{ customererrors }}</div> -->
                                    </div>
                                    <div class="col btn-groups text-left">
                                        <button type="submit" class="btn btn-primary" style="margin-top:25px;" v-on:click.prevent="fetchOrder" >
                                            Fetch
                                        </button>
                                        <!-- <button type="submit" class="btn btn-primary" style="margin-top:20px;" v-on:click.prevent="fetchOrder" >
                                            Print
                                        </button> -->

                                    </div>
                                </div>
   
                                <div class="form-group">
                                    <div class="alert alert-warning hide col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                            </form>

                            <template v-if="showList">
                                <p v-if="batchProcess && !batchComplete" class="alert-success p-2" id="processFetchBatchMsg">Current batch {{batchNo}} is processing please wait!</p>
                                <p v-if="batchError" class="alert-danger p-2" id="processErrorBatchMsg">{{batchErrorMsg}}<button type="button" class="close close-alert" v-on:click="batchError = false;batchErrorMsg = ''">×</button></p>
                                <data-table-filter-config :moduleName="'suggestedOrderList'" ref="filesuggestedOrderList" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                                    <!-- <div class="field-error">{{customer_error_msg}}</div> -->
                                    
                                    <section class="bg-white data-table">
                                       
                                            <custom-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange" :moduleName="'suggestedOrderList'" :position="'top'">
                                            </custom-pagination>
                                            <vue-good-table
                                                ref="listsuggestedOrderTable"
                                                mode="remote"
                                                title="Suggested Order"
                                                @on-page-change="onPageChange"
                                                @on-column-filter="onColumnFilter"
                                                @on-per-page-change="onPerPageChange"
                                                @on-sort-change="onSortChange"
                                                @on-select-all="onSelectAll"
                                                :totalRows="totalRecords"
                                                :columns="userColumns"
                                                :rows="rows"
                                                :pagination-options="{
                                                    enabled: false,
                                                    setCurrentPage:listCurrentPage,
                                                    perPage: perPage,
                                                }"
                                                :select-options="{
                                                enabled: true,
                                                selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                                selectionInfoClass: 'custom-class',
                                                selectionText: 'rows selected',
                                                clearSelectionText: 'clear',
                                                }"
                                                :search-options="{
                                                enabled: false,
                                                }">
                                                <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                                    <div :key="key">
                                                        <div>
                                                            {{props.formattedRow[props.column.field]}}
                                                        </div>
                                                    </div>
                                                </template>
                                                <div slot="selected-row-actions">
                                                    <!-- <template> -->
                                                        <button id="cutPo" v-on:click="createPo('create')" class="btn btn-primary">Cut PO</button>
                                                        <button id="processPo" v-on:click="createPo('process')" class="btn btn-primary">Process PO</button>
                                                    <!-- </template> -->
                                                    <!-- <template>
                                                        <button id="processPo" v-on:click="processPo('process')" class="btn btn-primary">Process PO</button>
                                                    </template> -->
                                                    
                                                </div>
                                            </vue-good-table>

                                            <custom-pagination
                                                :page-changed="onPageChange"
                                                :per-page-changed="onPerPageChange"
                                                >
                                            </custom-pagination>
                                    </section>
                                 </template>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";
import EventBus from "./event-bus";
import {commonMixins} from '../mixins/commonMixins';
import {contractMixins} from '../mixins/contractMixins';
import {dataTableMixins} from '../mixins/dataTableMixins';
let msgServer;
export default {
  name: "ContractCreate",
  components: {
    
    
    customAssetPagination: () => import('@/components/layout/CustomPagination'),
    
  },
  metaInfo() {
        return {
            title: "Suggested Order | " +process.env.COPYRIGHT_NAME
        }
  },
  mixins:[commonMixins,contractMixins,dataTableMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    warehouseArr:[],
    warehouse_id:'',
    warehouse_error_msg:'',
    vendor_id:'',
    vendorArr:[],
    loading:false,
    rows: [],
    totalRecords: 0,
    userColumns:[],
    columns: [
            {
                label: 'Item Number',
                field: 'item',
                filterable: true,
                fpFieldType:"text",
                width:'140px',
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Code", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'On Hand',
                field: 'quantity',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
             {
                label: 'On Order',
                field: 'order_quantity',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
             {
                label: 'Suggested Order',
                field: 'suggested_quantity',
                filterable: true,
                fpFieldType:"integer",
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Name", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                },
                sortable:false
            },
            {
                label: 'Cost',
                field: 'base_price',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Cost", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Min.',
                field: 'onhand_min_qty',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Cost", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Max.',
                field: 'onhand_max_qty',
                fpFieldType:"integer",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Cost", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
            {
                label: 'Vendor',
                field: 'vendor',
                fpFieldType:"text",
                filterable: true,
                hidden:false,
                filterOptions: {
                    enabled: false, // enable filter for this column
                    placeholder: "Phone", // placeholder for filter input
                    filterValue: '', // initial populated value for this filter
                    trigger: "enter" //only trigger on enter not on keyup
                }
            },
        ],
        selectedArray:[],
        showList:false,
        batchId:'',
        batchNo:'',
        batchProcess:false,
        batchComplete:false,
        batchError:false,
        batchErrorMsg:""
  }),
  watch:{

    //check permission change
    permissions: function (permissions) {
        var self = this;
        if (permissions.length > 0) {
            for (var i = 0; i < permissions.length; i++) {
                if (permissions[i].name == 'list_purchase_order' ) {
                    self.cantAccessPage = true;
                }
            }
        }
    }
  },
  created: function() {

  },
  beforeDestroy() {
        // Make sure to close the connection with the events server
        // when the component is destroyed, or we'll have ghost connections!
        msgServer.close();
    },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['warehouse']);
  },
  methods: {
      checkBatchStatus:function(){
                var self =  this;

                this.$sse(process.env.ROOT_API + '/check/batch-status/'+self.batchId, { format: 'json' }) // or { format: 'plain' }
                .then(sse => {
                    // Store SSE object at a higher scope
                    msgServer = sse;

                    // Listen for messages without a specified event
                    sse.subscribe('', data => {
                        if ( data.status == "1") {
                            self.batchProcess = false;
                            self.batchComplete = true;
                            self.loadList();
                            sse.close();

                        }else if (data.status == "2") {
                            self.batchProcess = false;
                            self.batchError = true;
                            self.batchErrorMsg = data.message;
                            sse.close();
                        }
                    });
                    
                })
                .catch(err => {
                    // When this error is caught, it means the initial connection to the
                    // events server failed.  No automatic attempts to reconnect will be made.
                    console.error('Failed to connect to server', err);
                });

            },
    cancelAll: function (cancelAll) {
      this.$refs.listsuggestedOrderTable.unselectAllInternal();
    },

    onSearchVendor(search, loading) {
        var self = this;
        if (search.length > 2) {

            loading(true);
            self.searchField(loading, search, 'vendor', '');
        }
    },

    onPageChange(params) {
        var self = this;
        this.updateParams({page: params.currentPage});
        this.listCurrentPage = params.currentPage;

      },
      fetchOrder:function(){
          var self = this;
            self.createOrders();
      },
      createOrders:function(){
        var self = this;
        var pFilter = {};
        self.warehouse_error_msg = '';

        if ( self.warehouse_id != null && self.warehouse_id.value) {
            pFilter.warehouse_id = self.warehouse_id.value;
        }else{
            self.warehouse_error_msg = 'Warehouse Required';
            return;
        }
        if (self.vendor_id && self.vendor_id.value){
            pFilter.vendor_id = self.vendor_id.value;
        }
        var fields = {
            orderFilter:pFilter,
        };
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/suggested-order/create",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.showList = true;
                    self.loadList();
                }else{
                    self.$swal('','No Items found','info');
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'order-list-error')

            }
        });
      },
      loadList() {

        var self = this;
        //get selected customers ids

        var selectedRows = [];
        self.serverParams.perPage=100;
        var pFilter = {};
        if ( self.warehouse_id != null && self.warehouse_id.value) {
            pFilter.warehouse_id = self.warehouse_id.value;
        }
        if (self.vendor_id && self.vendor_id.value){
            pFilter.vendor_id = self.vendor_id.value;
        }
        var fields = {

            page: self.serverParams.page,
            perPage: self.serverParams.perPage,
            filters: self.serverParams.columnFilters,
            orderFilter:pFilter,
            sort: self.serverParams.sort,
            flag: self.flag,
            selectedRows:selectedRows,
            action:self.action,
            selectedAll:self.serverParams.selectedAll

        };

        self.loading = true;

        self.firstLoad = 1;
        $.ajax({
            url: process.env.ROOT_API + "/suggested-order/list",
            type: "POST",
            data: fields,
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                // console.log(data);
                if (data.status == "success") {
                        self.rows = data.content.row;
                        self.totalRecords = data.content.totalRecords;

                        // for(var k=0;k< self.rows.length;k++){
                        //     if ($.inArray(self.rows[k].id, self.selectedArray) >= 0) {
                        //             self.$set(self.rows[k], 'vgtSelected', true);
                        //         }
                        // }

                        EventBus.$emit('clear-all-flags', false);
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'order-list-error')

            }
        });
    },
    createPo:function(flag){
        var self = this;
        var selectedRows = [];
        var data = this.$refs['listsuggestedOrderTable'].selectedRows;

        for (var i = 0; i < data.length; i++) {
            selectedRows.push(self.$refs['listsuggestedOrderTable'].selectedRows[i].id)
        }

         $.ajax({
            url: process.env.ROOT_API + '/suggested-po/create',
            type: "POST",
            data:{
                po_id:selectedRows,
                flag:flag
            },
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {

                self.loading = false;
                self.batchId = data.content.id;
                self.batchNo = data.content.batch;
                self.batchProcess = true;
                self.batchComplete = false;
                self.checkBatchStatus();
                self.$refs.filesuggestedOrderList.clearSelectAll();

            },
            error: function (jqXHR, exception) {
                self.loading = false;

                self.generateStatusCodeMessage(jqXHR,true,'process-vendor-po');
            }
        });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/SuggestedOrder.vue